import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SkipSelf } from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { BankAccount } from '../../../../banking/models/bank-account';
import { BehaviorSubject } from 'rxjs';
import { RadioButtonInputComponent } from '../../../../../ui/form-components/radio-button-input/radio-button-input.component';
import { ReviewEntryComponent } from '../../../../../ui/review-components/review-entry/review-entry.component';
import { AsyncPipe, DatePipe, NgIf } from '@angular/common';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { LeadingZeroPipe } from '../../../pipes/leading-zero.pipe';

@Component({
  selector: 'app-bank-account-accordion-radio-card',
  templateUrl: './bank-account-accordion-radio-card.component.html',
  styleUrls: ['./bank-account-accordion-radio-card.component.scss'],
  standalone: true,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]]
    }
  ],
  imports: [
    RadioButtonInputComponent,
    ReviewEntryComponent,
    DatePipe,
    AsyncPipe,
    NgIf,
    NgbAccordionModule,
    ReactiveFormsModule,
    LeadingZeroPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankAccountAccordionRadioCardComponent {
  @Input() bankAccount!: BankAccount;
  @Input() radioHidden = false;
  @Output() selected = new EventEmitter<void>();

  private _accordionIsExpanded = new BehaviorSubject<boolean>(false);
  public accordionIsExpanded$ = this._accordionIsExpanded.asObservable();

  public generatedRandomId = `account-${Math.random().toString(36).slice(2)}`;

  public toggleAccordionExpand(): void {
    this.accordionIsExpanded$.once(expanded => {
      this._accordionIsExpanded.next(!expanded);
    });
  }
}
